import {baseUrl} from'../config';

export const sessionController ={
    GetAllSessions:baseUrl+'/api/session'
}